import React from 'react';
import styles from './percentage.module.scss';

interface PassPercentageProps {
  value: number;
  // eslint-disable-next-line no-unused-vars
  handlePercentageChange: (percentage: number) => void;
}

export const PassPercentage: React.FC<PassPercentageProps> = ({ value, handlePercentageChange }) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const numericValue = parseFloat(value);

    if (value === "") {
      handlePercentageChange(0);
      return;
    }

    if (numericValue > 0 && numericValue <= 100) {
      handlePercentageChange(numericValue);
    }
  };

  return (
    <div className={styles.percentageContainer}>
      <label className={styles.heading} htmlFor="pass-percentage">
        Enter the required pass percentage for the learner:
      </label>
      <div className={styles.inputWrapper}>
        <input
          className={styles.percentageInput}
          type="text"
          pattern='[0-9]*'
          id="pass-percentage"
          data-testid="course-pass-percentage"
          value={value}
          onChange={handleChange}
        />
        <span className={styles.percentageSymbol}>%</span>
      </div>
      <p className={styles.subText}>
        This represents the minimum pass percentage the learner must achieve for
        this course.
      </p>
    </div>
  );
};